import { MappedCertificate, MappedSpeciality } from '../../models/user';
import { LanguageEnum } from '../../models/language.enum';
import { SexEnum } from '../../models/sex.enum';
import { CarLicenseEnum } from '../../models/carLicense.enum';

export function getUsersByCriteriaMongoQuery(options: {
  sex: SexEnum | null | undefined | string;
  car: number | null | undefined | string;
  language: LanguageEnum | null | undefined | string;
  certificates: MappedCertificate[] | null | undefined;
  specialities: MappedSpeciality[] | null | undefined;
}): { [key: string]: any } {
  const { car, language, certificates, specialities, sex } = options;
  const query: { [key: string]: any } = {};
  if (sex !== undefined && sex !== null && sex !== '') {
    query.sex = sex;
  }
  if (language !== undefined && language !== null && language !== '') {
    query.languages = language;
  }
  if (car !== undefined && car !== null && car !== '') {
    if (car === CarLicenseEnum.LICENSE_AVAILABLE) {
      query.car = {
        $in: [
          CarLicenseEnum.LICENSE_AVAILABLE,
          CarLicenseEnum.CAR_AND_LICENSE_AVAILABLE,
        ],
      };
    } else {
      query.car = car;
    }
  }
  if (certificates?.length) {
    query['certificates.id'] = {
      $in: certificates.map((c: MappedCertificate) => c.id),
    };
  }
  if (specialities?.length) {
    query['specialities.id'] = {
      $in: specialities.map((s: MappedSpeciality) => s.id),
    };
  }
  return query;
}
